import { cx } from "@/utils/cx";

export interface TimelineItemProps {
    id: string;
    position: "left" | "right";
    content: React.ReactNode;
    /** Applied as marginBottom for spacing from next item (computed by parent) */
    gapBottom?: number;
    /** Optional datetime label shown above the dot when day or hour changes */
    dateLabel?: string;
    className?: string;
}

const CENTER_COLUMN_CLASS = "relative flex shrink-0 w-6 items-center justify-center";

export function TimelineItem({
    position,
    content,
    gapBottom = 16,
    dateLabel,
    className,
}: TimelineItemProps) {
    const cardClass = "w-full max-w-[480px] rounded-xl bg-primary p-4 shadow-xs ring-1 ring-secondary";
    const hasDateLabel = dateLabel != null && dateLabel !== "";

    return (
        <div
            className={cx("relative flex w-full flex-col gap-1", className)}
            style={{ marginBottom: gapBottom }}
        >
            {/* Optional first row: date label only, same 3-column grid so label sits above the dot */}
            {hasDateLabel && (
                <div className="mb-3 flex w-full items-center gap-4">
                    <div className="flex min-w-0 flex-1" aria-hidden />
                    <div className={CENTER_COLUMN_CLASS}>
                        <span className="text-xs font-medium text-tertiary whitespace-nowrap">
                            {dateLabel}
                        </span>
                    </div>
                    <div className="flex min-w-0 flex-1" aria-hidden />
                </div>
            )}
            {/* Second row: card | dot | card — center column fixed width so cards stay aligned */}
            <div className="relative flex w-full items-start gap-4">
                <div className="flex min-w-0 flex-1 justify-end">
                    {position === "left" ? (
                        <div className={cardClass}>{content}</div>
                    ) : (
                        <div className="w-full max-w-[480px]" />
                    )}
                </div>
                <div className={CENTER_COLUMN_CLASS}>
                    <div className="h-3 w-3 shrink-0 rounded-full bg-tertiary ring-4 ring-primary" />
                </div>
                <div className="flex min-w-0 flex-1 justify-start">
                    {position === "right" ? (
                        <div className={cardClass}>{content}</div>
                    ) : (
                        <div className="w-full max-w-[480px]" />
                    )}
                </div>
            </div>
        </div>
    );
}
